import { phone } from "./phone";
export class BuildDlronTypes {
    static buildDlronTypes(dlronTypes, locale, currentCountry) {
        dlronTypes[locale.enUS] = {};
        dlronTypes[locale.enCA] = {};
        dlronTypes[locale.esUS] = {};
        dlronTypes[locale.esMX] = {};
        dlronTypes[locale.esPE] = {};
        dlronTypes[locale.esCO] = {};
        dlronTypes[locale.esCL] = {};
        dlronTypes[locale.ptBR] = {};
        dlronTypes[locale.esEC] = {};
        dlronTypes[locale.esPY] = {};
        //English - US
        dlronTypes[locale.enUS].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                greedy: true,
            },
            placeholder: "Phone Number",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.enUS].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(true, currentCountry),
            },
            placeholder: "Phone Number",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.enUS].zipcode = {
            validationMethods: { zipcodeUSValid: true },
            mask: "99999[-9999]",
            placeholder: "ZIP Code",
            autocomplete: "postal-code",
        };
        dlronTypes[locale.enUS].email = {
            validationMethods: { emailValid: true },
            placeholder: "Email Address",
            autocomplete: "email",
        };
        dlronTypes[locale.enUS].firstname = {
            validationMethods: {
                nameValid: "first name",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "First Name",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.enUS].lastname = {
            validationMethods: {
                nameValid: "last name",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "Last Name",
            autocomplete: "family-name",
            transform: "capitalize",
        };
        dlronTypes[locale.enUS].motherslastname = {
            validationMethods: {
                nameValid: "mothers last name",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "Mothers Last Name",
            autocomplete: "mothers-family-name",
            transform: "capitalize",
        };
        dlronTypes[locale.enUS].middlename = {
            validationMethods: {
                nameValid: "middle initial",
                minlength: 1,
                maxlength: 50,
            },
            placeholder: "Middle Initial",
            autocomplete: "additional-name",
            transform: "capitalize",
        };
        dlronTypes[locale.enUS].address = {
            placeholder: "Address",
            autocomplete: "street-address",
        };
        dlronTypes[locale.enUS].city = {
            placeholder: "City",
            autocomplete: "address-level2",
            transform: "capitalize",
        };
        dlronTypes[locale.enUS].state = {
            validationMethods: { stateValid: true },
            mask: "aa",
            placeholder: "State",
            autocomplete: "address-level1",
            transform: "uppercase",
        };
        dlronTypes[locale.enUS].comment = {
            placeholder: "Comments",
        };
        dlronTypes[locale.enUS].vin = {
            validationMethods: { vinValid: true },
            placeholder: "VIN",
            transform: "uppercase",
        };
        dlronTypes[locale.enUS].mileage = {
            mask: "[9999999]",
            placeholder: "Mileage",
        };
        dlronTypes[locale.enUS].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.enUS].money = {};
        dlronTypes[locale.enUS].date = {
            validationMethods: { dateValid: true },
            dataAttributes: { format: "MM/DD/YYYY", template: "MMM D YYYY" },
        };
        dlronTypes[locale.enUS].datepicker = {
            placeholder: "Select Date",
        };
        dlronTypes[locale.enUS].license = {
            validationMethods: { licenseValid: true },
            placeholder: "Driver's License #",
            transform: "uppercase",
        };
        dlronTypes[locale.enUS].ssn = {
            validationMethods: { ssnValid: true },
            mask: "999-99-9999",
            placeholder: "SSN",
        };
        dlronTypes[locale.enUS].file = {
            validationMethods: { fileValid: true },
        };
        dlronTypes[locale.enUS].preferredcontact = {};
        dlronTypes[locale.enUS].phoneType = {
            validationMethods: {
                phoneTypeValid: "",
            },
        };
        dlronTypes[locale.enUS].estimatedDateOfPurchase = {};
        //English - CA
        dlronTypes[locale.enCA].phone = dlronTypes[locale.enUS].phone;
        dlronTypes[locale.enCA].phoneShort = dlronTypes[locale.enUS].phoneShort;
        dlronTypes[locale.enCA].zipcode = {
            validationMethods: { zipcodeCAValid: true },
            mask: "a9a 9a9",
            placeholder: "Postal Code",
            autocomplete: "postal-code",
            transform: "uppercase",
        };
        dlronTypes[locale.enCA].email = dlronTypes[locale.enUS].email;
        dlronTypes[locale.enCA].firstname = dlronTypes[locale.enUS].firstname;
        dlronTypes[locale.enCA].lastname = dlronTypes[locale.enUS].lastname;
        dlronTypes[locale.enCA].motherslastname =
            dlronTypes[locale.enUS].motherslastname;
        dlronTypes[locale.enCA].middlename = dlronTypes[locale.enUS].middlename;
        dlronTypes[locale.enCA].address = dlronTypes[locale.enUS].address;
        dlronTypes[locale.enCA].city = dlronTypes[locale.enUS].city;
        dlronTypes[locale.enCA].state = {
            validationMethods: { provinceValid: true },
            mask: "aa",
            placeholder: "Province",
            autocomplete: "address-level1",
            transform: "uppercase",
        };
        dlronTypes[locale.enCA].comment = dlronTypes[locale.enUS].comment;
        dlronTypes[locale.enCA].vin = dlronTypes[locale.enUS].vin;
        dlronTypes[locale.enCA].mileage = dlronTypes[locale.enUS].mileage;
        dlronTypes[locale.enCA].color = dlronTypes[locale.enUS].color;
        dlronTypes[locale.enCA].money = dlronTypes[locale.enUS].money;
        dlronTypes[locale.enCA].date = dlronTypes[locale.enUS].date;
        dlronTypes[locale.enCA].datepicker = dlronTypes[locale.enUS].datepicker;
        dlronTypes[locale.enCA].license = dlronTypes[locale.enUS].license;
        dlronTypes[locale.enCA].ssn = {
            validationMethods: { sinValid: true },
            mask: "999-999-999",
            placeholder: "SIN",
        };
        dlronTypes[locale.enCA].file = dlronTypes[locale.enUS].file;
        dlronTypes[locale.enCA].preferredcontact =
            dlronTypes[locale.enUS].preferredcontact;
        dlronTypes[locale.enCA].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.enCA].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Spanish - US
        dlronTypes[locale.esUS].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                greedy: true,
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esUS].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: phone.getPhoneMask(true, currentCountry),
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esUS].zipcode = {
            validationMethods: { zipcodeUSValid: true },
            mask: "99999[-9999]",
            placeholder: "Código Postal",
            autocomplete: "postal-code",
        };
        dlronTypes[locale.esUS].email = {
            validationMethods: { emailValid: true },
            placeholder: "Correo Electrónico",
            autocomplete: "email",
        };
        dlronTypes[locale.esUS].firstname = {
            validationMethods: {
                nameValid: "primer nombre",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "Primer Nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esUS].lastname = {
            validationMethods: { nameValid: "apellido", minlength: 2, maxlength: 50 },
            placeholder: "Apellido",
            autocomplete: "family-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esUS].motherslastname = {
            validationMethods: {
                nameValid: "apellido materno",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "Apellido Materno",
            autocomplete: "mothers-family-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esUS].middlename = {
            validationMethods: {
                nameValid: "segundo nombre",
                minlength: 1,
                maxlength: 50,
            },
            placeholder: "Segundo Nombre",
            autocomplete: "additional-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esUS].address = {
            placeholder: "Dirección",
            autocomplete: "street-address",
        };
        dlronTypes[locale.esUS].city = {
            placeholder: "Ciudad",
            autocomplete: "address-level2",
            transform: "capitalize",
        };
        dlronTypes[locale.esUS].state = {
            validationMethods: { stateValid: true },
            mask: "aa",
            placeholder: "Estado",
            autocomplete: "address-level1",
            transform: "uppercase",
        };
        dlronTypes[locale.esUS].comment = {
            placeholder: "Comentarios",
        };
        dlronTypes[locale.esUS].vin = {
            validationMethods: { vinValid: true },
            placeholder: "VIN",
            transform: "uppercase",
        };
        dlronTypes[locale.esUS].mileage = {
            mask: "[9999999]",
            placeholder: "Milage",
        };
        dlronTypes[locale.esUS].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esUS].money = {};
        dlronTypes[locale.esUS].date = {
            validationMethods: { dateValid: true },
            dataAttributes: { format: "MM/DD/YYYY", template: "MMM D YYYY" },
        };
        dlronTypes[locale.esUS].datepicker = {};
        dlronTypes[locale.esUS].license = {
            validationMethods: { licenseValid: true },
            placeholder: "Licencia de Manejar",
            transform: "uppercase",
        };
        dlronTypes[locale.esUS].ssn = {
            validationMethods: { ssnValid: true },
            mask: "999-99-9999",
            placeholder: "Número Social",
        };
        dlronTypes[locale.esUS].file = dlronTypes[locale.enUS].file;
        dlronTypes[locale.esUS].preferredcontact =
            dlronTypes[locale.enUS].preferredcontact;
        dlronTypes[locale.esUS].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esUS].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Spanish - MX
        dlronTypes[locale.esMX].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                greedy: true,
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esMX].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: phone.getPhoneMask(true),
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esMX].mileage = {
            mask: "[9999999]",
            placeholder: "Kilometraje",
        };
        dlronTypes[locale.esMX].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esMX].firstname = {
            validationMethods: { nameValid: "nombre", minlength: 2, maxlength: 50 },
            placeholder: "Nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esMX].zipcode = dlronTypes[locale.esUS].zipcode;
        dlronTypes[locale.esMX].email = dlronTypes[locale.esUS].email;
        dlronTypes[locale.esMX].lastname = dlronTypes[locale.esUS].lastname;
        dlronTypes[locale.esMX].motherslastname =
            dlronTypes[locale.esUS].motherslastname;
        dlronTypes[locale.esMX].middlename = dlronTypes[locale.esUS].middlename;
        dlronTypes[locale.esMX].address = dlronTypes[locale.esUS].address;
        dlronTypes[locale.esMX].city = dlronTypes[locale.esUS].city;
        dlronTypes[locale.esMX].comment = dlronTypes[locale.esUS].comment;
        dlronTypes[locale.esMX].vin = dlronTypes[locale.esUS].vin;
        dlronTypes[locale.esMX].money = dlronTypes[locale.esUS].money;
        dlronTypes[locale.esMX].datepicker = dlronTypes[locale.esUS].datepicker;
        dlronTypes[locale.esMX].license = dlronTypes[locale.esUS].license;
        dlronTypes[locale.esMX].ssn = dlronTypes[locale.esUS].ssn;
        dlronTypes[locale.esMX].file = dlronTypes[locale.esUS].file;
        dlronTypes[locale.esMX].preferredcontact =
            dlronTypes[locale.esUS].preferredcontact;
        dlronTypes[locale.esMX].date = {
            validationMethods: { dateValid: true },
            dataAttributes: { format: "DD/MM/YYYY", template: "DD MM YYYY" },
        };
        dlronTypes[locale.esMX].state = {
            validationMethods: { stateValid: true },
            placeholder: "Estado",
            autocomplete: "address-level1",
        };
        dlronTypes[locale.esMX].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esMX].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Spanish - PE
        dlronTypes[locale.esPE].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esPE].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esPE].mileage = {
            mask: "[9999999]",
            placeholder: "Kilometraje",
        };
        dlronTypes[locale.esPE].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esPE].firstname = {
            validationMethods: { nameValid: "nombre", minlength: 2, maxlength: 50 },
            placeholder: "Nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esPE].zipcode = dlronTypes[locale.esUS].zipcode;
        dlronTypes[locale.esPE].email = dlronTypes[locale.esUS].email;
        dlronTypes[locale.esPE].lastname = dlronTypes[locale.esUS].lastname;
        dlronTypes[locale.esPE].motherslastname =
            dlronTypes[locale.esUS].motherslastname;
        dlronTypes[locale.esPE].middlename = dlronTypes[locale.esUS].middlename;
        dlronTypes[locale.esPE].address = dlronTypes[locale.esUS].address;
        dlronTypes[locale.esPE].city = dlronTypes[locale.esUS].city;
        dlronTypes[locale.esPE].comment = dlronTypes[locale.esUS].comment;
        dlronTypes[locale.esPE].vin = dlronTypes[locale.esUS].vin;
        dlronTypes[locale.esPE].money = dlronTypes[locale.esUS].money;
        dlronTypes[locale.esPE].datepicker = dlronTypes[locale.esUS].datepicker;
        dlronTypes[locale.esPE].license = dlronTypes[locale.esUS].license;
        dlronTypes[locale.esPE].ssn = dlronTypes[locale.esUS].ssn;
        dlronTypes[locale.esPE].file = dlronTypes[locale.esUS].file;
        dlronTypes[locale.esPE].preferredcontact =
            dlronTypes[locale.esUS].preferredcontact;
        dlronTypes[locale.esPE].date = {
            validationMethods: { dateValid: true },
            dataAttributes: { format: "DD/MM/YYYY", template: "DD MM YYYY" },
        };
        dlronTypes[locale.esPE].state = {
            validationMethods: { stateValid: true },
            placeholder: "Estado",
            autocomplete: "address-level1",
            transform: "uppercase",
        };
        dlronTypes[locale.esPE].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esPE].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Spanish - CO
        dlronTypes[locale.esCO].mileage = {
            mask: "[9999999]",
            placeholder: "Kilometraje",
        };
        dlronTypes[locale.esCO].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esCO].firstname = {
            validationMethods: { nameValid: "nombre", minlength: 2, maxlength: 50 },
            placeholder: "Nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esCO].phone = dlronTypes[locale.esUS].phone;
        dlronTypes[locale.esCO].phoneShort = dlronTypes[locale.esUS].phoneShort;
        dlronTypes[locale.esCO].zipcode = dlronTypes[locale.esUS].zipcode;
        dlronTypes[locale.esCO].email = dlronTypes[locale.esUS].email;
        dlronTypes[locale.esCO].lastname = dlronTypes[locale.esUS].lastname;
        dlronTypes[locale.esCO].motherslastname =
            dlronTypes[locale.esUS].motherslastname;
        dlronTypes[locale.esCO].middlename = dlronTypes[locale.esUS].middlename;
        dlronTypes[locale.esCO].address = dlronTypes[locale.esUS].address;
        dlronTypes[locale.esCO].city = dlronTypes[locale.esUS].city;
        dlronTypes[locale.esCO].comment = dlronTypes[locale.esUS].comment;
        dlronTypes[locale.esCO].vin = dlronTypes[locale.esUS].vin;
        dlronTypes[locale.esCO].money = dlronTypes[locale.esUS].money;
        dlronTypes[locale.esCO].date = dlronTypes[locale.esMX].date;
        dlronTypes[locale.esCO].datepicker = dlronTypes[locale.esUS].datepicker;
        dlronTypes[locale.esCO].license = dlronTypes[locale.esUS].license;
        dlronTypes[locale.esCO].ssn = dlronTypes[locale.esUS].ssn;
        dlronTypes[locale.esCO].file = dlronTypes[locale.esUS].file;
        dlronTypes[locale.esCO].preferredcontact =
            dlronTypes[locale.esUS].preferredcontact;
        dlronTypes[locale.esCO].state = {
            validationMethods: { departmentValid: true },
            placeholder: "Departamento",
            autocomplete: "address-level1",
        };
        dlronTypes[locale.esCO].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esCO].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Spanish - CL
        dlronTypes[locale.esCL].mileage = {
            mask: "[9999999]",
            placeholder: "Kilometraje",
        };
        dlronTypes[locale.esCL].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esCL].firstname = {
            validationMethods: { nameValid: "nombre", minlength: 2, maxlength: 50 },
            placeholder: "nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esCL].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                placeholder: "",
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esCL].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(true, currentCountry),
                placeholder: "",
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esCL].rut = {
            validationMethods: { rutValid: "" },
            placeholder: "RUT",
            mask: {
                mask: ["9.999.999-K", "99.999.999-K"],
                definitions: {
                    K: {
                        validator: "[0-9kK]",
                        casing: "upper",
                    },
                },
                jitMasking: true,
                greedy: false,
            },
        };
        dlronTypes[locale.esCL].zipcode = dlronTypes[locale.esUS].zipcode;
        dlronTypes[locale.esCL].email = dlronTypes[locale.esUS].email;
        dlronTypes[locale.esCL].lastname = dlronTypes[locale.esUS].lastname;
        dlronTypes[locale.esCL].motherslastname =
            dlronTypes[locale.esUS].motherslastname;
        dlronTypes[locale.esCL].middlename = dlronTypes[locale.esUS].middlename;
        dlronTypes[locale.esCL].address = dlronTypes[locale.esUS].address;
        dlronTypes[locale.esCL].city = dlronTypes[locale.esUS].city;
        dlronTypes[locale.esCL].comment = dlronTypes[locale.esUS].comment;
        dlronTypes[locale.esCL].vin = dlronTypes[locale.esUS].vin;
        dlronTypes[locale.esCL].money = dlronTypes[locale.esUS].money;
        dlronTypes[locale.esCL].datepicker = dlronTypes[locale.esUS].datepicker;
        dlronTypes[locale.esCL].license = dlronTypes[locale.esUS].license;
        dlronTypes[locale.esCL].ssn = dlronTypes[locale.esUS].ssn;
        dlronTypes[locale.esCL].file = dlronTypes[locale.esUS].file;
        dlronTypes[locale.esCL].preferredcontact =
            dlronTypes[locale.esUS].preferredcontact;
        dlronTypes[locale.esCL].date = dlronTypes[locale.esMX].date;
        dlronTypes[locale.esCL].state = dlronTypes[locale.esUS].state;
        dlronTypes[locale.esCL].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esCL].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Portuguese BR
        dlronTypes[locale.ptBR].middlename = dlronTypes[locale.enUS].middlename;
        dlronTypes[locale.ptBR].vin = dlronTypes[locale.enUS].vin;
        dlronTypes[locale.ptBR].mileage = dlronTypes[locale.enUS].mileage;
        dlronTypes[locale.ptBR].color = dlronTypes[locale.enUS].color;
        dlronTypes[locale.ptBR].money = dlronTypes[locale.enUS].money;
        dlronTypes[locale.ptBR].date = dlronTypes[locale.enUS].date;
        dlronTypes[locale.ptBR].datepicker = dlronTypes[locale.enUS].datepicker;
        dlronTypes[locale.ptBR].license = dlronTypes[locale.enUS].license;
        dlronTypes[locale.ptBR].ssn = dlronTypes[locale.enUS].ssn;
        dlronTypes[locale.ptBR].file = dlronTypes[locale.enUS].file;
        dlronTypes[locale.ptBR].preferredcontact =
            dlronTypes[locale.enUS].preferredcontact;
        dlronTypes[locale.ptBR].zipcode = {
            validationMethods: { zipcodeBRValid: true },
            mask: "99999-999",
            placeholder: "Código de Endereçamento Postal",
            autocomplete: "postal-code",
        };
        dlronTypes[locale.ptBR].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                greedy: true,
            },
            placeholder: "Telefone",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.ptBR].phoneShort = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(true, currentCountry),
                greedy: true,
            },
            placeholder: "Telefone",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.ptBR].email = {
            validationMethods: { emailValid: true },
            placeholder: "Email",
            autocomplete: "email",
        };
        dlronTypes[locale.ptBR].firstname = {
            validationMethods: { nameValid: "nome", minlength: 2, maxlength: 50 },
            placeholder: "Nome",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.ptBR].lastname = {
            validationMethods: {
                nameValid: "sobrenome",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "Sobrenome",
            autocomplete: "family-name",
            transform: "capitalize",
        };
        dlronTypes[locale.ptBR].motherslastname = {
            validationMethods: {
                nameValid: "sobrenome da mãe",
                minlength: 2,
                maxlength: 50,
            },
            placeholder: "Sobrenome da Mãe",
            autocomplete: "mothers-family-name",
            transform: "capitalize",
        };
        dlronTypes[locale.ptBR].address = {
            placeholder: "Endereço",
            autocomplete: "street-address",
        };
        dlronTypes[locale.ptBR].city = {
            placeholder: "Cidade",
            autocomplete: "address-level2",
            transform: "capitalize",
        };
        dlronTypes[locale.ptBR].state = {
            validationMethods: { stateValid: true },
            placeholder: "Estado",
            autocomplete: "address-level1",
        };
        dlronTypes[locale.ptBR].comment = {
            placeholder: "Mensagem",
        };
        dlronTypes[locale.ptBR].cpf = {
            validationMethods: { cpfValid: "" },
            mask: {
                mask: "999.999.999-99",
                greedy: true,
            },
            placeholder: "CPF",
        };
        dlronTypes[locale.ptBR].cnpj = {
            validationMethods: { cnpjValid: "" },
            mask: {
                mask: "99.999.999/9999-99",
                greedy: true,
            },
            placeholder: "CNPJ",
        };
        dlronTypes[locale.ptBR].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.ptBR].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        //Spanish - EC
        dlronTypes[locale.esEC].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                greedy: true,
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esEC].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: phone.getPhoneMask(true, currentCountry),
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esEC].mileage = {
            mask: "[9999999]",
            placeholder: "Kilometraje",
        };
        dlronTypes[locale.esEC].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esEC].firstname = {
            validationMethods: { nameValid: "nombre", minlength: 2, maxlength: 50 },
            placeholder: "Nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esEC].zipcode = {
            validationMethods: { zipcodeECPYValid: true },
            mask: "999999",
            placeholder: "Código postal",
            autocomplete: "postal-code",
        };
        dlronTypes[locale.esEC].email = dlronTypes[locale.esUS].email;
        dlronTypes[locale.esEC].lastname = dlronTypes[locale.esUS].lastname;
        dlronTypes[locale.esEC].motherslastname =
            dlronTypes[locale.esUS].motherslastname;
        dlronTypes[locale.esEC].middlename = dlronTypes[locale.esUS].middlename;
        dlronTypes[locale.esEC].address = dlronTypes[locale.esUS].address;
        dlronTypes[locale.esEC].city = dlronTypes[locale.esUS].city;
        dlronTypes[locale.esEC].comment = dlronTypes[locale.esUS].comment;
        dlronTypes[locale.esEC].vin = dlronTypes[locale.esUS].vin;
        dlronTypes[locale.esEC].money = dlronTypes[locale.esUS].money;
        dlronTypes[locale.esEC].datepicker = dlronTypes[locale.esUS].datepicker;
        dlronTypes[locale.esEC].license = dlronTypes[locale.esUS].license;
        dlronTypes[locale.esEC].ssn = dlronTypes[locale.esUS].ssn;
        dlronTypes[locale.esEC].file = dlronTypes[locale.esUS].file;
        dlronTypes[locale.esEC].preferredcontact =
            dlronTypes[locale.esUS].preferredcontact;
        dlronTypes[locale.esEC].date = {
            validationMethods: { dateValid: true },
            dataAttributes: { format: "DD/MM/YYYY", template: "DD MM YYYY" },
        };
        dlronTypes[locale.esEC].state = {
            validationMethods: { stateValid: true },
            placeholder: "Estado",
            autocomplete: "address-level1",
        };
        dlronTypes[locale.esEC].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esEC].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        dlronTypes[locale.esEC].dni = {
            validationMethods: { dniValid: "" },
            mask: "9999999999",
            placeholder: "Documento Nacional de Identificación",
        };
        //Spanish - PY
        dlronTypes[locale.esPY].phone = {
            validationMethods: {
                phoneNanpValid: phone.getPhoneFormat(false, currentCountry),
            },
            mask: {
                mask: phone.getPhoneMask(false, currentCountry),
                greedy: true,
            },
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esPY].phoneShort = {
            validationMethods: {
                phoneShortNanpValid: phone.getPhoneFormat(true, currentCountry),
            },
            mask: phone.getPhoneMask(true, currentCountry),
            placeholder: "Teléfono",
            autocomplete: "tel-national",
        };
        dlronTypes[locale.esPY].mileage = {
            mask: "[9999999]",
            placeholder: "Kilometraje",
        };
        dlronTypes[locale.esPY].color = {
            mask: { regex: "^[A-Za-z ]*$" },
            placeholder: "Color",
        };
        dlronTypes[locale.esPY].firstname = {
            validationMethods: { nameValid: "nombre", minlength: 2, maxlength: 50 },
            placeholder: "Nombre",
            autocomplete: "given-name",
            transform: "capitalize",
        };
        dlronTypes[locale.esPY].zipcode = {
            validationMethods: { zipcodeECPYValid: true },
            mask: "999999",
            placeholder: "Código postal",
            autocomplete: "postal-code",
        };
        dlronTypes[locale.esPY].email = dlronTypes[locale.esUS].email;
        dlronTypes[locale.esPY].lastname = dlronTypes[locale.esUS].lastname;
        dlronTypes[locale.esPY].motherslastname =
            dlronTypes[locale.esUS].motherslastname;
        dlronTypes[locale.esPY].middlename = dlronTypes[locale.esUS].middlename;
        dlronTypes[locale.esPY].address = dlronTypes[locale.esUS].address;
        dlronTypes[locale.esPY].city = dlronTypes[locale.esUS].city;
        dlronTypes[locale.esPY].comment = dlronTypes[locale.esUS].comment;
        dlronTypes[locale.esPY].vin = dlronTypes[locale.esUS].vin;
        dlronTypes[locale.esPY].money = dlronTypes[locale.esUS].money;
        dlronTypes[locale.esPY].datepicker = dlronTypes[locale.esUS].datepicker;
        dlronTypes[locale.esPY].license = dlronTypes[locale.esUS].license;
        dlronTypes[locale.esPY].ssn = dlronTypes[locale.esUS].ssn;
        dlronTypes[locale.esPY].file = dlronTypes[locale.esUS].file;
        dlronTypes[locale.esPY].preferredcontact =
            dlronTypes[locale.esUS].preferredcontact;
        dlronTypes[locale.esPY].date = {
            validationMethods: { dateValid: true },
            dataAttributes: { format: "DD/MM/YYYY", template: "DD MM YYYY" },
        };
        dlronTypes[locale.esPY].state = {
            validationMethods: { stateValid: true },
            placeholder: "Estado",
            autocomplete: "address-level1",
        };
        dlronTypes[locale.esPY].phoneType = dlronTypes[locale.enUS].phoneType;
        dlronTypes[locale.esPY].estimatedDateOfPurchase =
            dlronTypes[locale.enUS].estimatedDateOfPurchase;
        dlronTypes[locale.esPY].cedula = {
            validationMethods: { cedulaValid: "" },
            mask: "999999[9][9]",
            placeholder: "Cédula de Identidad",
        };
    }
}
